import { ToolProvider } from '@/backend/types'
import type { ToolRegistryItem } from '@/modules/Project/Tools/tool-types'
import { o4MiniTool } from './o4Mini'

export const o4MiniAzureTool: ToolRegistryItem = {
  ...o4MiniTool,
  provider: ToolProvider.azure_open_ai,
}
